module.exports = __webpack_public_path__ + "static/flags/MI-a936290872c33ae83a82e3aa8e2dd910.gif";